import { Icon, type IconTone } from './Icon';

/** Уход на чужой сайт: стрелка из рамки. Ставится у ссылок на профиль ВК. */
export function ExternalIcon({ size = 10, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={11} tone={tone}>
      <path d="M4 1 H10 V7" strokeWidth={1} />
      <path d="M10 1 L4.6 6.4" strokeWidth={1} />
      <path d="M8 7.4 V10 H1 V3 H3.6" strokeWidth={1} />
    </Icon>
  );
}
